// CDN selection with geo-based routing and fallback
//
// Videos (HLS) are geo-routed:
//   Americas (excl. US/CA/MX) -> primary: nas1.d.tube (Costa Rica), fallback: nas2
//   US, CA, MX, and rest of world -> primary: nas2.d.tube (France), fallback: nas1
//   MX moved to nas2 to offload nas1 bandwidth saturation.
//   Unknown/missing country defaults to nas2.
//
// Images (posters) are ALWAYS served from nas1: small, and a video whose
// files haven't reached the nas2 mirror yet still gets its poster.
//
// Region is detected via Cloudflare's CF-IPCountry header, injected into
// the page by nginx as window.__DTUBE_COUNTRY.
//
// 2026-09-20: nas2 was taken out of rotation (pool full, mirror drifted).
// 2026-09-30: video routing restored after the disk swap; images stay on nas1.
// Flip NAS2_VIDEO_ENABLED to false to send all video traffic back to nas1.
const NAS2_VIDEO_ENABLED: boolean = true;

const CDN_NAS1 = "https://nas1.d.tube";
const CDN_NAS2 = "https://nas2.d.tube";
const IMAGE_CDN = CDN_NAS1;

const AMERICAS_COUNTRIES = new Set([
  "GT", "BZ", "HN", "SV", "NI", "CR", "PA",
  "CU", "JM", "HT", "DO", "PR", "TT", "BB", "BS", "AG", "DM", "GD", "KN", "LC", "VC",
  "BR", "AR", "CO", "PE", "VE", "CL", "EC", "BO", "PY", "UY", "GY", "SR", "GF",
]);

declare global {
  interface Window {
    __DTUBE_COUNTRY?: string;
  }
}

function isAmericas(): boolean {
  const country = window.__DTUBE_COUNTRY;
  // Unknown/missing country -> default to nas2 (France).
  if (!country) return false;
  return AMERICAS_COUNTRIES.has(country);
}

export interface CdnUrls {
  /** Video host to try first. */
  primary: string;
  /** Video host to retry on if primary fails. */
  fallback: string;
  /** Image host (posters); never geo-routed. */
  images: string;
}

export function getCdnUrls(): CdnUrls {
  if (!NAS2_VIDEO_ENABLED) return { primary: CDN_NAS1, fallback: CDN_NAS1, images: IMAGE_CDN };
  return isAmericas()
    ? { primary: CDN_NAS1, fallback: CDN_NAS2, images: IMAGE_CDN }
    : { primary: CDN_NAS2, fallback: CDN_NAS1, images: IMAGE_CDN };
}

export function getVideoUrl(baseUrl: string, videoId: string): string {
  return `${baseUrl}/videos/${videoId}/master.m3u8`;
}

export function getPosterUrl(baseUrl: string, videoId: string): string {
  return `${baseUrl}/thumbnails/${videoId}.jpg`;
}
